import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import NewPasswordInput from './NewPasswordInput';

const ConditionsPassword = ({
  password,
  mustContainData,
  validatePassword,
  confirmPassword,
  handleConfirmPassword,
}) => {
  const theme = useTheme();
  return (
    <>
      <Stack
        sx={{
          background: theme.palette.primary.gradient,
          width: '90%',
          height: { lg: '200px', sm: '230px', xs: '260px' },
          borderRadius: '12px',
          mb: '50px',
          marginTop: '20px',
        }}
        justifyContent={'center'}
        alignItems={'center'}>
        <Stack width={'95%'}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              <img src='/assets/images/perfiles/info.svg' alt='' />
            </Box>

            <Typography
              sx={{
                paddingLeft: '10px',
              }}
              color={theme.palette.white.main}>
              Asegúrate de que tu contraseña tenga:
            </Typography>
          </Box>

          {mustContainData.map((item, key) => {
            if (item[1] === false || item[2] === false) {
              return (
                <Box key={key}>
                  <Box
                    key={key}
                    sx={{
                      display: 'flex',
                      paddingY: '7px',
                    }}>
                    {password.length === 0 ? (
                      <Box
                        sx={{
                          width: 20,
                          height: 20,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                        <img alt='' src='/assets/images/blankpassword.png' />
                      </Box>
                    ) : (
                      <CloseIcon
                        sx={{
                          padding: 0,
                          margin: 0,
                          color: theme.palette.red.main,
                        }}
                      />
                    )}

                    <Typography
                      sx={{
                        fontSize: theme.typography.button.fontSize,
                        paddingLeft: password.length === 0 ? '10px' : '5px',
                      }}
                      color={theme.palette.white.main}>
                      {item[0]}
                    </Typography>
                  </Box>
                </Box>
              );
            } else {
              return (
                <Box key={key}>
                  <Box
                    sx={{
                      display: 'flex',
                      paddingY: { md: '7px', xs: '2px' },
                    }}>
                    <DoneIcon style={{ color: theme.palette.secondary.main }} />

                    <Typography
                      sx={{
                        fontSize: theme.typography.button.fontSize,
                        paddingLeft: '5px',
                      }}
                      color={theme.palette.white.main}>
                      {item[0]}
                    </Typography>
                  </Box>
                </Box>
              );
            }
          })}
        </Stack>
      </Stack>
      <Box sx={{ width: '90%', mb: '50px', mt: '-10px' }}>
        <NewPasswordInput
          title={'Nueva contraseña'}
          password={password}
          validatePassword={validatePassword}
        />
      </Box>
      <Box sx={{ width: '90%', mb: '50px', mt: '-10px' }}>
        <NewPasswordInput
          title={'Repetir contraseña'}
          password={confirmPassword}
          validatePassword={handleConfirmPassword}
        />
      </Box>
    </>
  );
};

export default ConditionsPassword;
